<ng-template #rejectTemplate>
  <div class="box-detail">
    <div class="panel-detail page-content">
      <h1 class="text-center"><b>{{'Reject Journey Record' | translate}} {{flow.id}}</b></h1>
      <button class="btn close" type="button" mat-dialog-close></button>
      <mat-dialog-content class="mat-typography">
        <form [formGroup]="panelForm">
          <div class="row mb-0">
            <div class="col-md-12 text-center fs-20">
              <div class="mb-25">{{'Are you sure you would like to reject the whole flow record?' | translate}}</div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="blue-color required">{{'Reason for Rejection' | translate}}</label>
                <textarea
                  rows="3"
                  formControlName="cancelled_reason"
                  type="text"
                  class="form-control"
                  [ngClass]="{
                    'is-invalid':
                      (cancelled_reason.touched || cancelled_reason.dirty || submittedPanelForm) &&
                      cancelled_reason.invalid
                  }"
                ></textarea>
                <small
                  *ngIf="
                  cancelled_reason.invalid &&
                    (cancelled_reason.dirty || cancelled_reason.touched || submittedPanelForm)
                  "
                  class="form-text text-danger"
                  >{{ getErrorMessage("cancelled_reason") }}</small
                >
              </div>
            </div>
          </div>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button class="btn btn-secondary panel-detail-btn" mat-dialog-close>
          {{'CANCEL' | translate}}
        </button>
        <button
          class="btn btn-danger panel-detail-btn"
          (click)="submitPanel()"
          [disabled]="panelForm.invalid"
        >
          {{'REJECT' | translate}}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</ng-template>
